import PlataformaTipoForm from "./PlataformaTipoForm";
export default PlataformaTipoForm;